import itHook from './index';
export const useTrans = itHook.useTrans;
